"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalise = void 0;
const capitalise = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
exports.capitalise = capitalise;
